import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Shield, Check, Star } from 'lucide-react';
export function PricingSection() {
  return <Section background="cream-dark" id="pricing" data-id="element-57">
      <div className="max-w-3xl mx-auto" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-xl overflow-hidden border border-brand-gold/20" data-id="element-59">
          <div className="bg-brand-charcoal-dark p-8 text-center text-white relative overflow-hidden" data-id="element-60">
            <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-61"></div>
            <h2 className="text-3xl font-serif font-bold mb-2 relative z-10" data-id="element-62">
              Oferta Especial Limitada
            </h2>
            <p className="text-brand-gold relative z-10" data-id="element-63">
              Invierte en tu salud mental y productividad
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-64">
            <div className="flex justify-center items-baseline mb-8" data-id="element-65">
              <span className="text-5xl font-bold text-brand-charcoal-dark" data-id="element-66">
                $27
              </span>
              <span className="text-gray-500 ml-2 line-through text-xl" data-id="element-67">
                $97
              </span>
            </div>

            <p className="text-lg text-brand-charcoal/80 mb-8 max-w-lg mx-auto" data-id="element-68">
              Por el precio de un par de cafés, obtendrás el sistema exacto para
              drenar la ansiedad y recuperar tu enfoque.
            </p>

            <Button size="lg" className="w-full text-base sm:text-lg mb-6 shadow-xl shadow-brand-gold/20" onClick={() => {
            window.open('https://thehabitbalance.com/cart/51805726671131:1', '_blank');
          }} data-id="element-69">
              Obtener Acceso Inmediato
            </Button>

            <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-sm text-gray-500 mb-8" data-id="element-70">
              <div className="flex items-center" data-id="element-71">
                <Shield className="h-4 w-4 mr-2 text-brand-gold-dark" data-id="element-72" />
                Pago 100% Seguro
              </div>
              <div className="flex items-center" data-id="element-73">
                <Star className="h-4 w-4 mr-2 text-brand-gold-dark" data-id="element-74" />
                Acceso de por vida
              </div>
            </div>

            <div className="bg-brand-cream rounded-lg p-6 border border-brand-gold/10" data-id="element-75">
              <h4 className="font-bold text-brand-charcoal-dark mb-2 flex items-center justify-center gap-2" data-id="element-76">
                <Shield className="h-5 w-5 text-brand-gold-dark" data-id="element-77" />
                Garantía de Hierro de 30 Días
              </h4>
              <p className="text-sm text-brand-charcoal/70" data-id="element-78">
                Si no sientes una diferencia notable en tu claridad mental y
                niveles de estrés en los primeros 7 días, te devolvemos el 100%
                de tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}